module.exports = __webpack_public_path__ + "img/ícone-emblema-seguraça.2302ca16.svg";